import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { HeatPump } from '../../../../core/src/shared/enums';

export const HeatPumpTypeSelect = ({
  value,
  onChange,
  includeNibe,
}: {
  value: HeatPump;
  onChange: (value: HeatPump) => void;
  includeNibe: boolean;
}) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="heat-pump-type-label">
        <FormattedMessage
          id="settings.heatpump.hp_type"
          defaultMessage="Typ tepelného čerpadla"
        />
      </InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as HeatPump)}
        labelId="heat-pump-type-label"
        size="medium"
        label={
          <FormattedMessage
            id="settings.heatpump.hp_type"
            defaultMessage="Typ tepelného čerpadla"
          />
        }
      >
        <MenuItem value={HeatPump.Ecoone} key={HeatPump.Ecoone}>
          <FormattedMessage id="heat_pump.ecoone" defaultMessage="Ecoone" />
        </MenuItem>
        {includeNibe && (
          <MenuItem value={HeatPump.Nibe} key={HeatPump.Nibe}>
            <FormattedMessage id="heat_pump.nibe" defaultMessage="Nibe" />
          </MenuItem>
        )}
        <MenuItem value={HeatPump.Acond} key={HeatPump.Acond}>
          <FormattedMessage id="heat_pump.acond" defaultMessage="Acond" />
        </MenuItem>
      </Select>
    </FormControl>
  );
};
